import * as React from 'react';
import { SVGProps } from 'react';

const IconDrillingPartRightFilledSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 6a5.02 5.02 0 0 1 4.511-5v10A5.02 5.02 0 0 1 1 6ZM6.514 6.502V11A5.02 5.02 0 0 0 11 6.502H6.514ZM11 5.498A5.02 5.02 0 0 0 6.514 1v4.498H11Z" />
  </svg>
);
export default IconDrillingPartRightFilledSizeXs;
